import {
  MultiSelect,
  MultiSelectProps,
  Select,
  SelectProps,
} from '@mantine/core';

import { useGetManyGendersQuery } from '@api/genders.api';

type GenderSelectorProps =
  | (Omit<
      SelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple?: false;
    })
  | (Omit<
      MultiSelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple: true;
    });

export default function GenderSelector(props: GenderSelectorProps) {
  // ==========================================================================
  // Api
  // ==========================================================================
  const { data = [], isLoading } = useGetManyGendersQuery({
    sortBy: 'name',
    sortOrder: 'asc',
  });

  // ==========================================================================
  // Render
  // ==========================================================================
  return props.multiple ? (
    <MultiSelect
      {...props}
      searchable
      nothingFoundMessage="Nessun genere trovato"
      placeholder={
        props.value?.length || 0 > 0 ? undefined : 'Seleziona i generi'
      }
      data={data.map((gender) => ({
        value: gender.id,
        label: gender.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  ) : (
    <Select
      {...props}
      searchable
      nothingFoundMessage="Nessun genere trovato"
      placeholder="Seleziona il genere"
      data={data.map((gender) => ({
        value: gender.id,
        label: gender.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  );
}
